import './no-data.scss';
import { autoinject, bindable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

@autoinject()
export class NoData {
  @bindable
  message: string;

  @bindable
  title: string;

  constructor(private t: I18N) {}

  bind() {
    if (!this.message) {
      this.message = this.t.tr('general.noData');
    }
  }
}
